<template>







        <div class="iconsa">
            <div class="iconsa_row">
                <el-row :gutter="24">
                    <el-col :span="2" v-if="webW"><br></el-col>
                    <el-col :span="webW?4:12">
                        <div class="saitem" @click="gotoA(0)">
                            <div class="left"> <img src="../assets/img/ico1.png"></div>
                            <div class="right"><span>圣光临在</span></div>
                        </div>
                    </el-col>
<!--                     <el-col :span="webW?4:12">-->
<!--                        <div class="saitem" @click="gotoB()">-->
<!--                            <div class="left"> <img src="../assets/img/ico2.png"></div>-->
<!--                            <div class="right"><span>圣光之国</span></div>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :span="webW?4:12">-->
<!--                        <div class="saitem" @click="gotoA(1)">-->
<!--                            <div class="left"> <img src="../assets/img/ico3.png"></div>-->
<!--                            <div class="right"><span>资料下载</span></div>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :span="webW?4:12">-->
<!--                        <div class="saitem" @click="gotoA(2)">-->
<!--                            <div class="left"> <img src="../assets/img/ico4.png"></div>-->
<!--                            <div class="right"><span>新浪微博</span></div>-->
<!--                        </div>-->
<!--                    </el-col>-->
                    <el-col :span="webW?4:12">
                        <div class="saitem" @click="gotoA(3)">
                            <div class="left"> <img src="../assets/img/ico5.png"></div>
                            <div class="right"><span>在线视频</span></div>
                        </div>
                    </el-col>

                    <el-col :span="2"  v-if="webW"><br></el-col>
                </el-row>
            </div>

            <p class="webdesc">若您对网站有任何意见或者建议，请发邮件至 service@holylightbbs.com Copyright © 2025 圣光检索</p>
        </div>



</template>

<script>

    import {isWeb, lianjie} from '../api/common';

export default {
    data() {
        return{
            webW:true,


        }
    },
    methods: {

        gotoA(a){
            window.open(lianjie[a],'_blank')
        },
        gotoB( ){
           this.$router.push("Forum");
        },

    },created() {
        this.webW = isWeb();
     }
};
</script>

<style scoped>






    .iconsa{

        width: 100%;


        overflow: hidden;



        box-sizing: border-box;


    }
.iconsa_row{

    background: rgba(0, 0, 0, 0.3);
    padding: 10px 10px;



}
    .saitem{
        cursor: pointer;
    }
     .saitem .left{width: 50%;text-align: right;float: left;}
     .saitem .right{width: 50%;line-height: 50px;float: right;}
    .saitem .left img{width: 50px;height: 50px;}
    .saitem .right span{color: #f3f3f3;font-size: 10px;margin-left: 5px;}





</style>
